import gql from 'graphql-tag';

export const getSettlement = gql`
  query getSettlement($quoteId: String!) {
    getSettlement(quoteId: $quoteId) {
      orderId
      status
      approximateDelivery
      confirmedDelivery
      activeLeasesWithoutData {
        vehicleTitle
        contactNumber
      }
      dealer {
        name
        location
      }
      hasDocusign
      deliveryMessage
    }
  }
`;

export const createEmployeeEmbeddedUrl = gql`
  mutation createEmployeeEmbeddedUrl {
    createEmployeeEmbeddedUrl {
      url
    }
  }
`;

export const createEmployerEmbeddedUrl = gql`
  mutation createEmployerEmbeddedUrl($applicationId: String!) {
    createEmployerEmbeddedUrl(applicationId: $applicationId) {
      url
    }
  }
`;
